<template>
  <div>
    <p class="text-sm text-[#828282] mb-[1rem]">
      Persetujuan akhir untuk semua pengajuan lembur yang disetujui divisi.
    </p>

    <BTable
      :items="globalItems"
      :fields="globalFields"
      :busy="isLoading"
      responsive
      show-empty
      empty-text="Belum ada Approver Final yang diatur."
      class="align-middle mb-0 bordered-body-b-table"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <BSpinner class="align-middle mr-1" />
          <span>Memuat data...</span>
        </div>
      </template>

      <template #cell(approverFinal)="data">
        <div class="py-[.25rem]">
          <div class="text-sm font-semibold text-[#0F172A] leading-snug">
            {{ data.item.approverFinal }}
          </div>
          <div
            v-if="data.item.approverFinalRole"
            class="text-xs text-[#828282] leading-snug"
          >
            {{ data.item.approverFinalRole }}
          </div>
        </div>
      </template>

      <template #cell(action)="data">
        <div class="flex items-center justify-end">
          <BButton
            variant="link"
            size="sm"
            class="border rounded-lg !flex items-center gap-[.35rem] px-[.75rem] py-[.375rem] text-black hover:bg-slate-50"
            @click="handleUbahGlobal(data.item)"
          >
            <span class="k-edit-2 text-[15px] text-black" />
            <span class="text-xs font-medium text-black">Ubah Approver Final</span>
          </BButton>
        </div>
      </template>
    </BTable>

    <ModalConfirmation :modal="modalConfirm" />

    <DrawerApproverFinalGlobal
      :visible="isDrawerVisible"
      :global-data="selectedGlobal"
      :is-submitting="isSubmitting"
      @on-close="isDrawerVisible = false"
      @on-save="handleSaveGlobal"
      @on-delete="handleDeleteGlobal"
    />
  </div>
</template>

<style scoped>
::v-deep .btn-outline-danger,
::v-deep .btn-link {
  border-radius: 10px !important;
}

::v-deep .bordered-body-b-table tbody {
  box-shadow:
    inset 0 -1px 0 #ddd,
    inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd;
  border-radius: 0 0 15px 15px;
}
</style>

<script>
import ModalConfirmation from '../../components/ModalConfirmation.vue'
import DrawerApproverFinalGlobal from './DrawerApproverFinalGlobal.vue'
import { confirmModalMessage } from '../../helpers/string-html'
import {
  tableGlobalFields, showSuccess, showError,
  getGlobalFinalApprover, setGlobalFinalApprover, deleteGlobalFinalApprover,
  searchApproverUsers,
} from '../config'

export default {
  name: 'TabApproverFinalGlobal',
  components: {
    DrawerApproverFinalGlobal,
    ModalConfirmation,
  },
  data() {
    return {
      globalFields: tableGlobalFields,
      isDrawerVisible: false,
      selectedGlobal: {},
      globalItems: [],
      isLoading: false,
      isSubmitting: false,
      modalConfirm: {
        id: 'modal-confirm-delete-final-approver',
        title: '',
        description: '',
        negativeButtonAction: () => {},
        negativeButtonText: '',
        positiveButtonAction: () => {},
        positiveButtonText: '',
        closeButtonAction: () => {},
      },
    }
  },
  mounted() {
    this.fetchFinalApprover()
  },
  methods: {
    async fetchFinalApprover() {
      this.isLoading = true
      try {
        const approver = await getGlobalFinalApprover()
        if (approver && (approver.user_id || approver.user_name)) {
          let role = approver.role || ''
          if (!role && approver.user_name) {
            try {
              const matches = await searchApproverUsers(approver.user_name)
              const matched = matches.find(s => s.id === approver.user_id || s.name === approver.user_name)
              if (matched) {
                role = matched.division || matched.role || ''
              }
            } catch (e) {
              // fallback
            }
          }

          this.globalItems = [
            {
              id: approver.user_id,
              user_id: approver.user_id,
              approverFinal: approver.user_name,
              approverFinalRole: role || 'Finance',
              raw: approver.raw,
            },
          ]
        } else {
          this.globalItems = [
            {
              id: null,
              user_id: null,
              approverFinal: 'Belum diatur',
              approverFinalRole: 'Klik Ubah Approver Final untuk mengatur',
              isNotSet: true,
            },
          ]
        }
      } catch (error) {
        showError(error, 'Gagal memuat approver final global')
        if (this.globalItems.length === 0) {
          this.globalItems = [
            {
              id: null,
              user_id: null,
              approverFinal: 'Belum diatur',
              approverFinalRole: 'Klik Ubah Approver Final untuk mengatur',
              isNotSet: true,
            },
          ]
        }
      } finally {
        this.isLoading = false
      }
    },
    handleUbahGlobal(item) {
      this.selectedGlobal = item
      this.isDrawerVisible = true
    },
    async handleSaveGlobal(newApprover) {
      if (!newApprover) return
      this.isSubmitting = true
      try {
        const userId = Number(newApprover.id || newApprover.user_id)
        await setGlobalFinalApprover(userId)

        showSuccess('Perubahan Berhasil Disimpan!')
        this.isDrawerVisible = false
        await this.fetchFinalApprover()
      } catch (error) {
        showError(error, 'Gagal Memperbarui Data!')
      } finally {
        this.isSubmitting = false
      }
    },
    handleDeleteGlobal(item) {
      const approverName = item?.approverFinal || this.globalItems[0]?.approverFinal || 'Approver Final'
      this.modalConfirm.title = 'Hapus Approver Final Global?'
      this.modalConfirm.description = confirmModalMessage(
        `Approver final global <strong>${approverName}</strong> akan dihapus untuk semua divisi. Apakah Anda ingin melanjutkan?`,
      )
      this.modalConfirm.negativeButtonText = 'Batalkan'
      this.modalConfirm.negativeButtonAction = () => {
        this.$bvModal.hide(this.modalConfirm.id)
      }
      this.modalConfirm.positiveButtonText = 'Ya, Hapus'
      this.modalConfirm.positiveButtonAction = async () => {
        try {
          await deleteGlobalFinalApprover()
          showSuccess('Perubahan Berhasil Disimpan!')
          this.isDrawerVisible = false
          this.$bvModal.hide(this.modalConfirm.id)
          await this.fetchFinalApprover()
        } catch (error) {
          showError(error, 'Gagal Memperbarui Data!')
        }
      }
      this.modalConfirm.closeButtonAction = () => {
        this.$bvModal.hide(this.modalConfirm.id)
      }

      this.$bvModal.show(this.modalConfirm.id)
    },
  },
}
</script>
